import { Component, ElementRef, inject, input, PLATFORM_ID, signal, ViewChild, OnInit, computed, Output, EventEmitter } from '@angular/core';
import { JobDetails } from '../../models/details.model';
import { TranslocoModule } from '@jsverse/transloco';
import { TruncatePipe } from "../../../../shared/pipes/truncate.pipe";
import { DatePipe, isPlatformBrowser, NgTemplateOutlet } from '@angular/common';
import { ToBanglaNumberPipe } from '../../../../shared/pipes/toBanglaNumber.pipe';

const Default_Published_Date = 'Jan 1, 0001'

@Component({
  selector: 'app-summary',
  imports: [TranslocoModule, TruncatePipe, DatePipe, ToBanglaNumberPipe, NgTemplateOutlet],
  templateUrl: './summary.html',
  styleUrl: './summary.scss'
})
export class Summary implements OnInit {
  private platformId = inject(PLATFORM_ID)
  private isBrowser = signal(isPlatformBrowser(this.platformId))
  isSmallDevice = signal(false)
  isShowLocation = signal(false);
  experience = signal('');
  jobDetails = input<JobDetails | null>(null)
  defaultPublishDate = Default_Published_Date
  @ViewChild('locationWrapper') locationWrapper!: ElementRef;

  @Output() locationClicked = new EventEmitter<void>();

  readonly locationList = computed(() => {
    const loc = this.jobDetails()?.JobLocation ?? '';
    return loc.split(',').map(s => s.trim()).filter(Boolean);
  });

  readonly isMultipleLocations = computed(() => this.locationList().length > 2);

  toggleLocation() {
    this.isShowLocation.set(!this.isShowLocation())
  }

  ngOnInit(): void {
    if (this.isBrowser()) {
      this.checkScreenSize();
      this.splitExperience(this.jobDetails()?.experience ?? '')
    }
  }

  checkScreenSize() {
    if (this.isBrowser()) {
      this.isSmallDevice.set(window.innerWidth <= 740);
    }
  }

  splitExperience(experience: string): void {
    if (!this.isBrowser() || !experience) {
      return;
    }
    const experienceHtml = experience || '';
    const parser = new DOMParser();
    const exp = parser.parseFromString(experienceHtml, 'text/html');
    const expItem = Array.from(exp.querySelectorAll('li'));

    if (expItem.length > 0) {
      this.experience.set(`<ul><li>${expItem[0].innerHTML.trim()}</li></ul>`);
    }
  }
}